import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { messages } from './messages';
import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { Text, TextType } from 'ui-components/components/text';

import style from './shipment-limit-option-content.module.less';
import sharedStyle from '../plan-details.module.less';

/**
 * @typedef {import('../../../../../../../prop-types/subscription-data-types.d.ts').MonetaryValue} MonetaryValue
 */

/**
 * @param {object} props
 * @param {MonetaryValue} props.cost
 * @param {boolean} props.shouldShowIncludedForZeroCost
 * @returns {React.JSX.Element}
 */
const ShipmentLimitCost = ({ cost, shouldShowIncludedForZeroCost }) => {
  if (cost?.value) {
    return (
      <FormattedMessage
        {...messages.shipmentLimitAdditionalCost}
        values={{
          cost: <FormattedCurrency currencyCode={cost?.code} value={cost.value} />,
        }}
      />
    );
  }

  if (shouldShowIncludedForZeroCost) {
    return <FormattedMessage {...messages.includedAbbreviation} />;
  }

  return <FormattedCurrency currencyCode={cost?.code} fractionDigits={0} value={0} />;
};

/**
 * @param {object} props
 * @param {number} props.shipmentLimitCount
 * @param {MonetaryValue} props.shipmentLimitCost
 * @param {boolean} props.shouldShowIncludedForZeroCost
 * @returns {React.JSX.Element}
 */
export const ShipmentLimitOptionContent = ({ shipmentLimitCount, shipmentLimitCost, shouldShowIncludedForZeroCost }) => {
  return (
    <>
      <Text
        className={style['shipment-limit-option-count']}
        element='span'
        textType={TextType.Paragraph}
        value={<FormattedNumber value={shipmentLimitCount} />}
      />
      <Text
        className={sharedStyle['plan-option-content-cost']}
        element='span'
        textType={TextType.Caption}
        value={<ShipmentLimitCost cost={shipmentLimitCost} shouldShowIncludedForZeroCost={shouldShowIncludedForZeroCost} />}
      />
    </>
  );
};
